export default __webpack_public_path__ + "static/equal-opportunity-lender-white-28730d6a9904a14da0ae5c3577a3f660.svg";